// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__lBa1brFGVc{margin:var(--dixa-size-spacer-300) var(--dixa-size-spacer-500)}`, "",{"version":3,"sources":["webpack://./src/assets/components/teamPageLegacy/components/loadingDropdownItem/loadingDropdownItem.module.scss"],"names":[],"mappings":"AAEA,kBACE,8DAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.root {\n  margin: var(--dixa-size-spacer-300) var(--dixa-size-spacer-500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__lBa1brFGVc`
};
export default ___CSS_LOADER_EXPORT___;
